export default __webpack_public_path__ + "static/media/organic.8b76448c.png";